import { put, call, takeEvery } from "redux-saga/effects";
import * as apis from "../../network/apis/role";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import { ROUTE_PATHS } from "../../utils/RoutesPaths";

function* getRolesListSaga({ payload }) {
  try {
    yield put(
      actions.getRolesResponse({
        list: [],
        meta: {},
      })
    );
    const response = yield call(apis.getRoles, payload);
    yield put(
      actions.getRolesResponse({
        list: response.data.data,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      })
    );
    if (+response.headers["current-page"] > +response.headers["total-pages"]) {
      yield put(
        actions.getRolesRequest({
          ...payload,
          page: +response.headers["total-pages"],
        })
      );
    }
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

function* updateStatusRoleSaga({ payload }) {
  try {
    const response = yield call(apis.updateStatusRole, payload);
    yield put(actions.updateRoleStatusResponse(response.data.data));
    yield put(actions.getRolesRequest());
    yield showSuccessMsg(response?.data?.message, true);
  } catch (err) {
    yield err.response && showErrorMsg(err.response?.data?.message);
  }
}

function* getRoleSaga({ payload }) {
  try {
    const response = yield call(apis.getRole, payload);
    yield put(actions.getRoleResponse(response.data.data));
  } catch (err) {
    yield err.response && showErrorMsg(err.response?.data?.message);
  }
}

function* createRoleSaga({ payload }) {
  try {
    const response = yield call(apis.createRole, payload);
    yield put(actions.createRoleResponse(response.data.data));
    yield put(actions.getRolesRequest());
    yield showSuccessMsg("New Role Successfully Created!", true);
  } catch (err) {
    yield err.response && showErrorMsg(err.response?.data?.message);
  }
}

function* deleteRoleSaga({ payload }) {
  try {
    const response = yield call(apis.deleteRole, payload);
    yield put(actions.getRolesRequest());
    yield payload.history.push(ROUTE_PATHS.roleManagement);
    yield showSuccessMsg(response?.data?.message, true);
  } catch (err) {
    yield err.response && showErrorMsg(err.response?.data?.message);
  }
}

function* editRoleSaga({ payload }) {
  try {
    const response = yield call(apis.editRole, payload);
    yield showSuccessMsg(response?.data?.message, true);
  } catch (err) {
    yield err.response && showErrorMsg(err.response?.data?.message);
  }
}

function* promoteRoleSaga({ payload }) {
  try {
    const response = yield call(apis.promoteRole, payload);
    yield put(actions.promoteRoleResponse(response.data.data));
    yield showSuccessMsg(response?.data?.message, true);
  } catch (err) {
    yield err.response && showErrorMsg(err.response?.data?.message);
  }
}

function* demoteRoleSaga({ payload }) {
  try {
    const response = yield call(apis.demoteRole, payload);
    yield put(actions.demoteRoleResponse(response.data.data));
    yield showSuccessMsg(response?.data?.message, true);
  } catch (err) {
    yield err.response && showErrorMsg(err.response?.data?.message);
  }
}

function* getSingleRoleSaga({ payload }) {
  try {
    const response = yield call(apis.getSingleRole, payload);
    yield put(actions.getSingleRoleResponse(response.data.data));
    yield showSuccessMsg(response?.data?.message, true);
  } catch (err) {
    yield err.response && showErrorMsg(err.response?.data?.message);
  }
}

function* updateSingleRoleSaga({ payload }) {
  try {
    const response = yield call(apis.updateSingleRole, payload);
    yield put(actions.updateSingleRoleResponse(response.data.data));
    yield put(actions.getRolesRequest());
    yield showSuccessMsg(response?.data?.message, true);
  } catch (err) {
    yield err.response && showErrorMsg(err.response?.data?.message);
  }
}

export default function* RolesSaga() {
  yield takeEvery(types.GET_ROLES_LIST_REQUEST, getRolesListSaga);
  yield takeEvery(types.GET_ROLE_REQUEST, getRoleSaga);
  yield takeEvery(types.UPDATE_ROLE_STATUS_REQUEST, updateStatusRoleSaga);
  yield takeEvery(types.CREATE_ROLE_REQUEST, createRoleSaga);
  yield takeEvery(types.DELETE_ROLE_REQUEST, deleteRoleSaga);
  yield takeEvery(types.EDIT_ROLE_REQUEST, editRoleSaga);
  yield takeEvery(types.PROMOTE_ROLE_REQUEST, promoteRoleSaga);
  yield takeEvery(types.DEMOTE_ROLE_REQUEST, demoteRoleSaga);
  yield takeEvery(types.GET_SINGLE_ROLE_REQUEST, getSingleRoleSaga);
  yield takeEvery(types.UPDATE_SINGLE_ROLE_REQUEST, updateSingleRoleSaga);
}
